module.exports = __webpack_public_path__ + "static/media/details__to-do.574cc9ed.svg";